<template>
    <div
        id="kt_header_mobile"
        class="header-mobile align-items-center"
        v-bind:class="headerClasses"
    >
        <!--begin::Aside Mobile Toggle-->
        <button
            v-if="asideEnabled"
            class="btn p-0 burger-icon burger-icon-left"
            id="kt_aside_mobile_toggle"
        >
            <span></span>
        </button>
        <!--end::Aside Mobile Toggle-->

        <!--begin::Toolbar-->
        <div class="d-flex align-items-center ml-auto">
            <!--begin: Language bar -->
            <language-select right />
            <!--end: Language bar -->

            <!--begin: Notifications -->
            <b-dropdown
                size="sm"
                variant="link"
                toggle-class="topbar-item text-decoration-none mobile"
                no-caret
                right
                no-flip
                @show="show"
                @hide="hide"
                ref="dropdown"
            >
                <template v-slot:button-content>
                    <div class="btn btn-icon">
                        <i class="fas fa-bell">
                            <div class="badge-container" v-if="unreadMessages">
                                <span></span>
                            </div>
                        </i>
                    </div>
                </template>
                <b-dropdown-text tag="div">
                    <form>
                        <StDropdownNotification
                            @goToPage="goToPage"
                            :notificationsVisible="notificationsVisible"
                            :notificationMessages="notificationMessages"
                        />
                    </form>
                </b-dropdown-text>
            </b-dropdown>
            <!--end: Notifications -->

            <!--begin::Topbar Mobile Toggle-->
            <StQuickUser />
            <!--end::Topbar Mobile Toggle-->
        </div>
        <!--end::Toolbar-->
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import StQuickUser from '@/modules/layout/components/extras/offcanvas/QuickUser.vue';
import StDropdownNotification from '@/modules/layout/components/extras/dropdown/DropdownNotification.vue';
import LanguageSelect from '@/shared/i18n/LanguageSelect.vue';
import moment from 'moment';

export default {
    name: 'HeaderMobile',
    components: {
        StQuickUser,
        StDropdownNotification,
        LanguageSelect,
    },
    props: {
        isAtlasPublicView: {
            type: Boolean,
            default: false,
        },
        isMaintenance: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            notificationsVisible: false,
            notificationMessages: []
        }
    },
    computed: {
        ...mapGetters(['layoutConfig', 'getClasses']),
        ...mapGetters({
            userMessages: 'notifications/inApp/userMessages',
            listPeriod: 'notifications/inApp/listPeriod',
            unreadMessages: 'notifications/inApp/unreadNotifications'
        }),

        userIcon() {
            return process.env.BASE_URL + 'media/svg/icons/general/User.svg';
        },

        /**
         * Get classes for mobile header
         * @returns {null|*}
         */
        headerClasses() {
            const classes = this.getClasses('header_mobile') || [];
            const all = this.isMaintenance ? [...classes, 'header-custom'] : classes;
            return all.length ? all.join(' ') : null;
        },

        /**
         * Check if the left aside menu is enabled
         * @returns {boolean}
         */
        asideEnabled() {
            return !!this.layoutConfig('aside.self.display');
        },
    },
    methods: {
        ...mapActions({
            getUserMessages: 'notifications/inApp/getUserMessages',
        }),
        ...mapMutations({
            setListPeriod: 'notifications/inApp/setListPeriod',
        }),
        show() {
            this.notificationsVisible = true;
            this.getUserMessages(this.listPeriod)
            .then(()=> {
                this.notificationMessages = this.userMessages;
            })
        },
        hide() {
            this.notificationsVisible = false;
            const now = new Date();
            const endDate = moment(now).add(1, 'day').format('YYYY-MM-DD');
            const startMonth = moment(now).subtract(1, 'months').format('YYYY-MM-DD');
            const listPeriod = {
                startDate: startMonth,
                endDate: endDate
            }
            this.setListPeriod(listPeriod);
        },
        goToPage(item) {
            this.$refs.dropdown.hide(true);
            // For now only complains and applications will have notification(s) (in-app)
            // Once other sources will be added this need to be updated accordingly
            if (item.message.message_source) {
                const PAGE_LINKS = {
                    application: 'applicationView',
                    complain: 'complainView',
                };
                const name = PAGE_LINKS[item.message.message_source];
                this.$router.push({
                    name,
                    params: {
                        id: item.recipient.recipient_identification_id,
                    },
                });
                // In case the current page is application view
                // Routing to same route needs to refresh the page to get the data
                if (this.$route.name === 'applicationView') {
                    this.$router.go(this.$router.currentRoute)
                }
            }
        }
    }
};
</script>